import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserData } from "components/customHooks/userDataContext";
import { getUserOrgDetails } from "apiHandler/actions";
import FullWidthTabs from "components/TabsComponent";
import { BackButton } from "components/helpers";
import { Grid, TextField } from "@mui/material";

const TimeSheetLandingPage = () => {
  const navigate = useNavigate();
  const userData = useUserData();
  const [supervisorName, setSupervisorName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [employeeID, setEmployeeID] = useState(userData?.email);
  const [employeeName, setEmployeeName] = useState(
    userData?.first_name + " " + userData?.last_name
  );

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        user_id: userData?.email,
      };
      const response = await getUserOrgDetails(payload);
      if (response && response.length > 0) {
        const data = response[0];
        setOrganizationName(data.org_name);
        setSupervisorName(
          data.supervisor_first_name + " " + data.supervisor_last_name
        );
      }
    };
    fetchData();
  }, []);

  return (
    <div className="check-patient-modal" style={{ margin: "auto" }}>
      <Grid container spacing={2}>
        <Grid container item spacing={1}>
          <Grid item xs={10} sm={10} md={10}>
            <BackButton onClick={() => navigate(-1)} />
          </Grid>
          <Grid item xs={2} sm={2} md={2}>
            <button
              style={{
                float: "right",
                border: "none",
                color: "#d91a5f",
                padding: "3px",
              }}
              onClick={() => navigate("/login")}
            >
              <h4>Log Out</h4>
            </button>
          </Grid>
        </Grid>
        <Grid container item spacing={1}>
          <Grid item xs={6} sm={6} md={3}>
            <span style={{ color: "#cb3366" }}>Employee ID</span>
            <TextField
              variant="standard"
              type="text"
              className="full-width"
              value={employeeID}
              onChange={(e) => setEmployeeID(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <span style={{ color: "#cb3366" }}>Employee Name</span>
            <TextField
              variant="standard"
              type="text"
              className="full-width"
              value={employeeName}
              onChange={(e) => setEmployeeName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <span style={{ color: "#cb3366" }}>Supervisor Name</span>
            <TextField
              variant="standard"
              type="text"
              className="full-width"
              value={supervisorName}
              onChange={(e) => setSupervisorName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <span style={{ color: "#cb3366" }}>Organization</span>
            <TextField
              variant="standard"
              type="text"
              className="full-width"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <FullWidthTabs />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default TimeSheetLandingPage;
